export default __webpack_public_path__ + "images/b92209124dda7beafa5b3500ec6c9ec8-halloweenhaunt.webp";